import Vue from "vue";
import store from "@/store/index.js";
import App from "./App.vue";
import { routerPromise } from "./router/index.js";
import { i18nPromise } from "./plugins/i18n.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import "./assets/style/rate-my-tactic.css";
import "./registerServiceWorker";

import { faCaretDown, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretDown, faCircleUser);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Promise.all([routerPromise, i18nPromise]).then((results) => {
  const [router, i18n] = results;
  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
